import { useEffect, useRef } from "react";

export function useScrollToError(error: string | undefined, extraDeps: unknown[] = []) {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (error && rootRef.current) {
      rootRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      const input = rootRef.current.querySelector("input, select, textarea");
      if (input) (input as HTMLElement).focus();
    }
  }, [error, ...extraDeps]);

  return rootRef;
}
